import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'VOLUME 1',
  subtitle: 'Team Sports Master-Vault',
  desc: '50 complete lesson sessions',
  features: 'Soccer · Basketball · Volleyball · Handball · Team Tactics'
}, {
  color: '🟡',
  title: 'VOLUME 2',
  subtitle: 'Individual Excellence',
  desc: '50 complete lesson sessions',
  features: 'Athletics · Gymnastics · Personal Fitness · Skill Development'
}, {
  color: '🟠',
  title: 'VOLUME 3',
  subtitle: 'The Minor Games Collection',
  desc: '50 complete lesson sessions',
  features: 'Cooperative Games · Tag Games · Relay Races · Fun Challenges'
}, {
  color: '🔴',
  title: 'VOLUME 4',
  subtitle: 'The Assessment Toolkit',
  desc: 'Complete evaluation system',
  features: 'Rubrics · Progress Tracking · Student Self-Assessment · Parent Reports'
}, {
  color: '🟣',
  title: 'VOLUME 5',
  subtitle: 'Visual Cues & Skill Cards',
  desc: '120+ classified teaching resources',
  features: 'All Sports · All Levels · All Positions · Instant Correction Cues'
}, {
  color: '⭐',
  title: 'VOLUME 6',
  subtitle: 'The Yearly PE Planner',
  desc: 'Advanced planning tools',
  features: 'Annual Calendar · Unit Maps · Season Blocks · Weekly Templates'
}];
const features = ['Annual planning calendar', 'Complete ready-to-run lessons', 'Predefined learning objectives', 'Evaluation and assessment sheets', 'Student progress tracking', 'Small-group and large-group adaptations', 'Variations for different age groups and skill levels'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-270">
      <div className="max-w-5xl mx-auto" data-id="element-271">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-272">
          The 6 Complete Volumes
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-273">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-274">
              <div className="flex items-center gap-3 mb-4" data-id="element-275">
                <span className="text-2xl" data-id="element-276">{tomo.color}</span>
                <div data-id="element-277">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-278">
                    {tomo.title}
                  </h3>
                  <p className="text-[#FF6B00] font-bold text-lg leading-tight" data-id="element-279">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-280">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-281">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-282">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-283">
            What every volume includes
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 max-w-3xl mx-auto" data-id="element-284">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-285">
                <span className="text-[#00C853] text-lg flex-shrink-0" data-id="element-286">✅</span>
                <span data-id="element-287">{f}</span>
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}